// Phase 0 (d): Übernimmt der CompanyFlex-Client auf dem Mac tel:-Links? Till klickt die Links an.
const NUMMERN = [
  { label: 'Büro Minimusiker (Festnetz, mit Leerzeichen)', tel: '+49 251 3966054' },
  { label: 'Büro ohne Leerzeichen', tel: '+492513966054' },
  { label: 'Nationale Schreibweise', tel: '0251 3966054' },
];

export function TelTest() {
  return (
    <main className="teltest">
      <h2>Test: Telefonnummern anklicken</h2>
      <p>
        Bitte jeden Link einmal anklicken und notieren, welches Programm sich öffnet
        (CompanyFlex-Client, FaceTime, nichts). Es wird nur gewählt, wenn du im Programm noch
        bestätigst.
      </p>
      <ul>
        {NUMMERN.map((n) => (
          <li key={n.tel}>
            <a href={`tel:${n.tel.replace(/\s+/g, '')}`}>{n.tel}</a> — {n.label}{' '}
            <button onClick={() => void navigator.clipboard.writeText(n.tel)}>Kopieren</button>
          </li>
        ))}
      </ul>
      <p className="muted">
        Öffnet sich nicht der CompanyFlex-Client: In FaceTime unter Einstellungen → „Standard für
        Anrufe“ lässt sich ein anderes Programm wählen, sofern es tel:-Links unterstützt.
      </p>
    </main>
  );
}
